"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const galleryItems = [{
  id: 1,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg",
  alt: "The Future is behind us Album Cover",
  caption: "The Future is behind us",
  link: "https://open.spotify.com/album/1MJuWQASjalAll5aMpn0CO?si=yFUwj3GMRDyilLckFLUXew&nd=1&dlsi=111cfc30e16341cd"
}, {
  id: 2,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-AAOM-scaled.jpg?v=zbnk4i7u8cj",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-AAOM-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-AAOM-scaled.jpg",
  alt: "AAOM",
  caption: "AN AUDIENCE OF MOUNTAINS",
  link: "https://old-water.ffm.to/anaudienceofmountains"
}, {
  id: 3,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Aguanta-scaled.jpg?v=zol4suubkzc",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Aguanta-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Aguanta-scaled.jpg",
  alt: "Ether Dreams Album Cover",
  caption: "Aguanta",
  link: "https://old-water.ffm.to/aguantafeatselvamonte"
}, {
  id: 4,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Wayside-Treasures-scaled.jpg?v=djd9kra0j7v",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Wayside-Treasures-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Wayside-Treasures-scaled.jpg",
  alt: "WT",
  caption: "Wayside Treasures",
  link: "https://old-water.ffm.to/waysidetreasures"
}, {
  id: 5,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=b3mcv65zhmg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=vbcrzzcrp5",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=p2477wozr3n",
  alt: "TNI",
  caption: "The New Invention",
  link: "https://emubands.ffm.to/thenewinvention"
}, {
  id: 6,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Mountain-Edits-scaled.jpg?v=0kt9wu3w4aca",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Mountain-Edits-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-Mountain-Edits-scaled.jpg",
  alt: "ME",
  caption: "Mountain Edits",
  link: "https://old-water.ffm.to/mountainedits"
}, {
  id: 7,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=lal2umesad",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=at7ls0p27em",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=te4rnf0u3y",
  alt: "VI",
  caption: "Volume I",
  link: "https://open.spotify.com/album/09puHGfkLZeMwMQAwcPoav?si=6YMVmC5cT4mnMSDjRI0U5g"
}, {
  id: 8,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-OWJT2-scaled.jpg",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-OWJT2-scaled.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-OWJT2-scaled.jpg",
  alt: "VII",
  caption: "Volume II",
  link: "https://owjamtracks.ffm.to/volumeii"
}, {
  id: 9,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=d972kj788pp",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=ous4jjwy5i",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=06qk1vot83t",
  alt: "SF",
  caption: "Smithfield: The Soundtrack",
  link: "https://oldwater.ffm.to/smithfield-thesoundtrack"
}, {
  id: 10,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-DS1.jpg",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-DS1.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-DS1.jpg",
  alt: "DS",
  caption: "Dirty Selfie",
  link: "https://dirtyselfie.ffm.to/dirtyselfie"
}, {
  id: 11,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg",
  alt: "Up To Our Necks Album Cover",
  caption: "Up To Our Necks",
  link: "https://open.spotify.com/album/46ssCtzJmw8Lyp6nzFJnPZ?si=voPyUVUqRQuTMazNbx0eKg&nd=1&dlsi=6b6bf8f07ddb40c2"
}, {
  id: 12,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png-wvc-sizes",
  alt: "Artefacts Album Cover",
  caption: "Artefacts",
  link: "https://open.spotify.com/album/76iCtRZi4mRsxMQhFciRFI?si=idWzmJHhSlydVVVOYc5iaA&nd=1&dlsi=25b04ad1f6f84f57"
}, {
  id: 13,
  src: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-EIH-TPIDA.jpg",
  srcset: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-EIH-TPIDA.jpg",
  sizes: "https://oldwatermusic.com/wp-content/uploads/2026/07/reduced-EIH-TPIDA.jpg",
  alt: "The Past I dead ahead Album Cover",
  caption: "The Past Is dead ahead",
  link: "https://open.spotify.com/album/4m2YpfwNtaPr13IH6DRYvN?si=musl6U1gSF2oYn_cWpSPSw&nd=1&dlsi=d09a600dface42af"
}, {
  id: 14,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg",
  alt: "Ones & Zeros Album Cover",
  caption: "Ones & Zeros",
  link: "https://open.spotify.com/album/1xaQKi6HFiglEiWFQyVNLw?si=GDaEOMB_S5iEoUeqN0IF5g&nd=1&dlsi=f9982957dcb9454c"
}, {
  id: 15,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png-wvc-sizes",
  alt: "Up to our necks - Radio Edit Album Cover",
  caption: "Up to our necks - Radio Edit",
  link: "https://open.spotify.com/album/0nZ08GwFmeXt9SdGUc7G9J?si=0CVZ7cygRcq6EknZpo5wsw&nd=1&dlsi=8d261db815f14d5e"
}, {
  id: 16,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg",
  alt: "Invisible colours Album Cover",
  caption: "Invisible colours",
  link: "https://open.spotify.com/album/6U0t6oX5J62A91dd6WkW11?si=wtee6fD-SuiAgo74lTovCw&nd=1&dlsi=500bf5bd03fe4079"
}, {
  id: 17,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg",
  alt: "As You Mean to Go On Album Cover",
  caption: "As You Mean to Go On",
  link: "https://soundcloud.com/ruthowensmusic/sets/asyoumeantogoon"
}, {
  id: 18,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg",
  alt: "Myoho Valley Youtube Album Cover",
  caption: "Myoho Valley Youtube",
  link: "https://youtube.com/@myohovalleyyt?si=p3UK18I7RlLUN6S4"
}, {
  id: 19,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/norris-brown-website.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/norris-brown-website.png",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/norris-brown-website.png",
  alt: "Norris-Brown Album Cover",
  caption: "Norris-Brown",
  link: "https://www.norris-brown.com/home"
}, {
  id: 20,
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png",
  alt: "Coffee & Milk: Soundtrack Album Cover",
  caption: "Coffee & Milk: Soundtrack",
  link: "#"
}];
const displayItems = [...galleryItems, ...galleryItems];
export default function Albumdiscographygrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="254078" id="albumdiscographygrid" className="bg-background text-foreground overflow-hidden ![padding:10px_0px_10px_0px] !h-[160px]">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes carouselScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `
    }} />
      
      <div className="w-full px-0">
        <div ref={ref} className={`flex w-fit transition-all duration-1000 ease-out animate-[carouselScroll_40s_linear_infinite] hover:[animation-play-state:paused] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {displayItems.map((item, i) => <div key={`${item.id}-${i}`} data-index={i} className="group relative overflow-hidden rounded-md aspect-[1/1] shadow-lg bg-muted border border-border/50 hover:shadow-[0_0_20px_rgba(255,255,255,0.1)] transition-all duration-500 flex-shrink-0 w-[100px] md:w-[140px] mx-2">
              <Link to={item.link} newTab className="block w-full h-full">
                <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-background/80 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out flex items-end justify-center p-6 backdrop-blur-sm">
                  <h3 className="text-foreground font-mono text-sm md:text-base font-medium text-center tracking-widest uppercase translate-y-4 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                    {item.caption}
                  </h3>
                </div>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}